@if (soundService.isMuted()) {
  <img alt="mute" src="assets/images/svgs/mute.svg" />
} @else {
  <img alt="sound" src="assets/images/svgs/sound.svg" />
}
